import axios from 'axios'
import { showLoading, hideLoading } from 'react-redux-loading-bar'

export function requestFacebookData() {
	return {
		type: 'REQUEST_FACEBOOK_DATA'
	}
}

export function receiveFacebookData( data ) {
	return {
		type: 'RECEIVE_FACEBOOK_DATA',
		payload: data
	}
}

export function getFacebookData() {
	return function( dispatch ) {
		return axios({
				url: siteData.api_base_url + 'fb',
				timeout: 20000,
				method: 'get',
				responseType: 'json'
			})
			.then( function( response ) {
				dispatch( receiveFacebookData( response.data ) )
			})
			.catch( function( error ) {
				console.log( error, 'error' );
			})
	}
}
